import { useState } from "react";
import { faqs } from "@/mocks/content";

export default function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  return (
    <section id="faq" className="py-20 md:py-28 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-14">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-3">
            Frequently Asked Questions
          </h2>
          <p className="text-foreground-600 text-base md:text-lg">
            Everything you need to know about the AllChinaBuy Spreadsheet
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden transition-all"
            >
              <button
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
              >
                <span className="text-base md:text-lg font-semibold text-foreground-950 pr-4">{faq.q}</span>
                <i
                  className={`ri-add-line text-foreground-500 flex-shrink-0 transition-transform duration-300 w-5 h-5 flex items-center justify-center ${
                    openIdx === idx ? "rotate-45" : ""
                  }`}
                ></i>
              </button>

              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIdx === idx ? "max-h-96 pb-5" : "max-h-0"
                }`}
              >
                <p className="px-6 text-foreground-600 leading-relaxed text-sm md:text-base">
                  {faq.a}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* FAQPage Schema.org */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": faqs.map((faq) => ({
              "@type": "Question",
              "name": faq.q,
              "acceptedAnswer": {
                "@type": "Answer",
                "text": faq.a,
              },
            })),
          })}
        </script>
      </div>
    </section>
  );
}